import { IconButton, Box } from '@mui/material'
import CustomButton from 'components/buttons/CustomButton/CustomButton'
import CustomText from 'components/common/CustomText/CustomText'
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext'
import { useRegistryContext } from 'context/RegistryContext'
import { useUsersContext } from 'context/UsersContext'
import { useDeleteRegistry } from 'hooks/useRegistries'
import { useRevokeUser } from 'hooks/useUsers'
import DeleteIcon from 'icons/DeleteIcon'
import RevokeUserIcon from 'icons/RevokeUserIcon'
import React, { useState } from 'react'
import { snackbarService } from 'services/snackbarService'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'

interface Props {
  registryId: number;
  registryName: string;
  onClose: () => void;
  refetch?: () => void;
}

export default function DeleteRegistryButton({ registryId, registryName, onClose, refetch }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const [open, setOpen] = useState<boolean>(false);

  const { mutate: deleteMutation, isLoading } = useDeleteRegistry(
    (data: any) => {
      handleClose();
      snackbarService.showSnackbar('Registry has been deleted successfully', 'success');
      refetch?.();
    },
    (err: any) => console.log('err', err),
  )

  const deleteRegistry = async () => {
    deleteMutation(registryId);
  }

  const handlePress = () => {
    setOpen(true);
  }

  const handleClose = () => {
    onClose();
    setOpen(false);
  }

  return (
    <>
      <IconButton className={globalStyles.popoverButtonContainer} onClick={handlePress}>
        <Box className={globalStyles.popoverIconContainer}>
          <DeleteIcon size={16} />
        </Box>
        <CustomText text="Delete" ml="5px" color={colors.black} />
      </IconButton>

      <CustomDialog
        open={open}
        title={'Delete registry'}
        message={`Are you sure you want to delete “${registryName}” registry?`}
        alignText='left'
        buttons={[
          <CustomButton
            key='cancel'
            variant='outlined'
            text='Cancel'
            onClick={handleClose}
            disabled={isLoading}
            height={35}
          />,
          <CustomButton
            key='delete'
            variant='filled'
            color='error'
            text='Delete'
            onClick={deleteRegistry}
            loading={isLoading}
            height={35}
          />,
        ]}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
